import Logo from './Logo'
import BrandName from './BrandName'
import DownIcons from '@/icons/DownIcons'
import { useAppStore } from '@/stores/useAppStore'

interface HeadProps {
    sideBarFull: boolean
}

const Head: React.FC<HeadProps> = () => {
    const { setSideBarFull, sideBarFull } = useAppStore()

    return (
        <div
            className={`flex items-center gap-2 justify-center ${
                sideBarFull ? 'justify-between' : 'justify-center'
            }`}
        >
            <div>
                <div className="py-4 items-center justify-center hidden">
                    <Logo
                        className={
                            sideBarFull ? 'w-[54px] h-[54px]' : 'w-4 h-4'
                        }
                    />
                </div>

                <BrandName />
            </div>

            <DownIcons
                className={`${!sideBarFull ? 'hidden' : 'block'} transition-all icon-small rotate-[-90deg] cursor-pointer`}
                onClick={() => {
                    setSideBarFull(!sideBarFull)
                }}
            />
        </div>
    )
}

export default Head
